/** @jsxImportSource @emotion/react */
import React, { ComponentProps, useEffect, useState } from 'react';
import { css, jsx } from '@emotion/react';
import { FieldProps } from 'react-final-form';
import Field from './Field';
import { colors } from '@atlaskit/theme';
import Button from '../button';
import CrossIcon from '@atlaskit/icon/glyph/cross';

const ImageField: React.FC<ComponentProps<typeof Field> & {onImageSelect: (image: any)=> void; placeHolder?: React.ReactNode}> = ({
  name,
   placeHolder,
                                                                                                     onImageSelect,
  ...props
}) => {
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [preview, setPreview] = useState<any>(null);

  // create a preview as a side effect, whenever selected file is changed
  // useEffect(() => {
  //   if (!selectedFile) {
  //     setPreview(undefined);
  //     return
  //   }
  //   const objectUrl = URL.createObjectURL(selectedFile)
  //   setPreview(objectUrl);
  //
  //   // free memory when ever this component is unmounted
  //   return () => URL.revokeObjectURL(objectUrl)
  // }, [selectedFile]);

  return (
    <Field name={name} {...props}>
      {({ input: { value, onChange, ...input } }) => {
        const handleChange = ({
          target,
        }: React.ChangeEvent<HTMLInputElement>) => {
          console.log('handleChange', target.files);

          if (!target.files || target.files.length === 0) {
            // setSelectedFile(undefined);
            return;
          }
          const file = target.files[0];
          if(file.size >= 500000) {
            alert(`Logo has to be smaller than 0.5MB`);
            return;
          }
          // I've kept this example simple by using the first image instead of multiple
          setSelectedFile(file);
          onImageSelect(file);
          const objectUrl = URL.createObjectURL(file);
          onChange(objectUrl);
          setPreview(objectUrl);
        };
        // const handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        //   onChange(target.files) // instead of the default target.value
        // };
        return (
          <div>
            <label
              htmlFor="image-field"
              css={css`
                cursor: pointer;
                position: relative;
                height: 4rem;
                width: 100%;
                border: 2px solid transparent;
                display: flex;
                align-items: center;
               &:hover {
               #remove-button {
                 opacity: 1;
               }
               }
              `}
            >
              {value && (
                <React.Fragment>
                  <img
                  src={value as string}
                  css={css`
                    max-height: 100%;
                    max-width: 100%;
                    padding: 0.5rem;
                    vertical-align: middle;
                  `}
                  alt="logo"
                />
                <div id="remove-button" css={css`
                    opacity: 0;
                    margin-left: 0rem;
                    align-self: flex-start;
                    margin-top: -0.5rem;
                    background: white;
                  `}><Button
                  spacing="compact"
                  iconBefore={<CrossIcon label="Remove" size="small"/>}
                  // appearance="subtle"
                  // @ts-ignore
                  onClick={(e) => {e.preventDefault(); onChange(null);}}
                /></div>
                </React.Fragment>)}

              {!value && <div css={css`
                  height: 100%;
                 flex: 1;
                 border: 2px solid transparent;
                 padding: 0.5rem;
                 display: flex;
                 align-items: center;
                 border-radius: 3px;
                 justify-content: center;
                 border-color: ${colors.N40};
                 transition: background-color 0.2s ease-in-out,border-color 0.2s ease-in-out;

                &:hover {
                  background: ${colors.backgroundHover()};
                }`}>{placeHolder}</div>}
              <input
                {...input}
                accept="image/*"
                onChange={handleChange}
                type="file"
                id="image-field"
                style={{ display: 'none' }}
              />
            </label>
          </div>
        );
        {
          /*<input {...input} type="file" onChange={handleChange} css={css`width: 100%; height: 100%; position: absolute; opacity: 0; cursor: pointer`}/>*/
        }
      }}
    </Field>
  );
};

export default ImageField;
